import React from 'react';
import { Table } from 'antd';
import './style/pageTable.style.scss';
import { PaginationConfig } from 'antd/lib/table';

export interface PageTableProps {
  readonly size: 'small' | 'middle' | 'default';
  readonly columns: any;
  readonly loadingFunc: boolean;
  readonly data: any;
  readonly pagination?: number | PaginationConfig;
  readonly testId?: string;
}

const PageTable = ({ size, columns, loadingFunc, data, ...props }) => {
  const paginationObj = typeof props.pagination === 'number' ? { pageSize: props.pagination } : props.pagination;
  return (
    <Table
      className='table--content'
      size={size}
      rowClassName={(_, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
      pagination={paginationObj}
      columns={columns}
      loading={loadingFunc}
      data-testid={props.testId || 'page-table'}
      dataSource={data}
      {...props}
    />
  );
};

export default PageTable;
